import { useQuery } from "@apollo/client";
import { ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryDocument, ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment } from "../../../generated";
import { ComponentQueryLoader } from "../component-query-loader";
import { EcfmgHeader } from "./ecfmg-header";

interface EcfmgHeaderContainerProps {}

export const EcfmgHeaderContainer: React.FC<EcfmgHeaderContainerProps> = () => {
  const { data, loading, error } = useQuery(ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryDocument);

  return (
    <ComponentQueryLoader
        loading={loading}
        error={error}
        hasData={data?.applicantUserCurrent}
        hasDataComponent={
            <EcfmgHeader data={data?.applicantUserCurrent as ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment} />
        }
    />
  )
};